import * as React from 'react';

interface Props {
  value: string;
  onChangeRange: (value: string) => void;
}

const RangePicker = (props: Props) => {

  const {
    value,
    onChangeRange,
  } = props;

  // @ts-ignore
  const changeRange = React.useCallback((e) => {
    onChangeRange(e.target.value);
  });

  return (
    <input
      value={value}
      onChange={changeRange}
      type='range'
      min='0.1'
      max='1'
      step='0.1' />
  );
};

export default React.memo(RangePicker);
